import {
  EventTypeStyle,
  getEventTypeStyle,
  getPropertyColorIndex,
  PROJECT_COLORS,
} from 'src/utils/BigCalendarColourGeneratorUtils';
import React from 'react';
import { ICalendarEvent } from 'src/pages/Calendar/types';

const resolveEventClassName = (eventType: string): string => {
  if (eventType === 'walkthrough') {
    return 'walkthrough-event';
  }

  if (eventType === 'key-pickup') {
    return 'key-pickup-event';
  }

  return 'service-event';
};

const getEventStyle = (event: ICalendarEvent) => {
  const eventTypeStyle: EventTypeStyle = getEventTypeStyle(event.eventType);

  // Get project color for the circle.
  const projectColor: string = event.propertyName
    ? PROJECT_COLORS[
        getPropertyColorIndex(event.propertyName, PROJECT_COLORS.length)
      ]
    : '#dee2e6';

  return {
    className: `custom-calendar-event ${resolveEventClassName(event.eventType)}`,
    style: {
      backgroundColor: eventTypeStyle.backgroundColor,
      borderRadius: '8px',
      opacity: 0.95,
      color: eventTypeStyle.textColor,
      fontWeight: '600' as const,
      fontSize: '13px',
      boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
      paddingLeft: '30px',
      position: 'relative' as const,
      ['--project-color' as any]: projectColor,
      ['--project-glow' as any]: `${projectColor}33`,
    } as React.CSSProperties,
  };
};

export { getEventStyle };
